import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion'
import React, { useContext, useEffect, useRef } from 'react'
import { useOutsideClick } from '../../utils/hooks'
import Button from '../General/Button'
// import {
//   HiOutlinePencil,
//   HiOutlineDocumentSearch,
//   HiOutlineX,
// } from 'react-icons/hi'
import '../../assets/css/components/Display/FloatingMenu.css'
import { FloatingMenuContext } from '../../context/FloatingMenuContext'
import { PdfButton, PdfViewProps } from './PdfView'
// import {
//   AiFillPrinter,
//   AiOutlineCreditCard,
//   AiOutlineSend,
//   AiTwotoneBank,
// } from 'react-icons/ai'
// import { BiCategory, BiHide, BiShow } from 'react-icons/bi'
// import {
//   MdGppGood,
//   MdPointOfSale,
//   MdQrCode,
//   MdTrackChanges,
// } from 'react-icons/md'
// import { FaBoxOpen } from 'react-icons/fa'
// import { IoMdPricetag } from 'react-icons/io'
// import {
//   RiFileHistoryLine,
//   RiFolderReceivedLine,
//   RiRefund2Line,
// } from 'react-icons/ri'
// import {
//   BsDownload,
//   BsFillEyeFill,
//   BsFillEyeSlashFill,
//   BsFillPersonBadgeFill,
//   BsStack,
// } from 'react-icons/bs'
// import { GiJoin } from 'react-icons/gi'
// import { GiCancel } from 'react-icons/gi'
// import { IoDocumentsOutline, IoEyeSharp } from 'react-icons/io5'
// import { TiPrinter } from 'react-icons/ti'
// import { PdfButton, PdfViewProps } from './PdfView'
/**
 * FloatingMenu: componente pequeño utilizado principalment
 * en tablas para el desplieque de funcionalidades de cada registro.
 * La funcionalidad varia dependiendo de las propiedades que se
 * decidan pasar, las cuales deben corresponder con el tipo de dato
 * mostrado en la tabla.
 *
 * Opciones:
 * @param {ReactElement} children Elemento pasado al FloatingMenu. Usualmente
 * consiste en un icono de 3 puntos verticales con la funcionalidad de mostrar
 * el FloatingMenu al ser pulsado
 * @param {boolean} visible Propiedad que determina si el FloatindMenu se muestra
 * @param {object} options Objeto que contienes las funciones soportadas por el FloatingMenu.
 * Dentro del objeto options se encuentran las siguientes Funciones:
 *  - onDelete: para borrar un registro
 *  - onEdit: para editar un registro
 *  - onDetails: funcionalidad de mostrar detalles del registro (poco untilizado)
 * Las demas opciones dentro del objeto options son particulares de cada modulo.
 * Se recomiendas agregar funcionalidades nuevas en este objeto en la medida que
 * los nuevos modulos las vayan requiriendo
 */
const FloatingMenu: React.FC<FloatingMenuProps> = ({
  children,
  visible,
  options,
  onClose,
}) => {
  const {
    onEdit,
    onDelete,
    onDetails,
    onBank,
    onSubCategory,
    onAssociated,
    onTaxMachine,
    onTracking,
    onCompound,
    addRawMaterial,
    onPrice,
    setVisible,
    setNotVisible,
    cardVisible,
    onRefund,
    onAdd,
    onReprint,
    withholdingIVA,
    withholdingISLR,
    otherWitholding,
    aeWithholding,
    OnPrintProps,
    onConvertToSale,
    onClients,
    onSales,
    onCredit,
    onDisable,
    onEnable,
    onComplete,
    onCancel,
    onAssembly,
    onFiles,
    onDownload,
    onSendToCatalog,
    onDeleteFromCatalog,
    onCreditNote,
    onShow,
    onCustomButtons,
    onCost,
    onAddSubCategory,
    onAddEditInvoice,
    watchPurchase,
    watchSale,
    onDownloadDigitalInvoice,
    onDownloadIvaRetention,
    onDownloadIslrRetention,
    onDeletePurchase,
    onRetention,
    onRetentionISLR,
    onAddPayment,
    onAddReceivedProducts,
    onReturn,
    onReturnEdit,
    watchIncome,
    watchOutflow,
    onSendWhatsappMessage,
    onCancelSale,
    onCancelInvoice,
    onDay,
    onMonth,
    onAnnual,
    onWatchAccounts,
    onPay,
    onWatchDocument,
    onWatchDetails,
  } = options
  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, () => onClose())

  const { cardStates, selectedValue } = useContext(FloatingMenuContext)

  const callback = (e) => {
    if (e.code === 'Escape') onClose()
  }

  useEffect(() => {
    if (visible) {
      window.addEventListener('keydown', callback)
    }
    return () => {
      window.removeEventListener('keydown', callback)
    }
    //eslint-disable-next-line
  }, [visible])

  useEffect(() => {
    console.log('cardStates...', selectedValue)
  }, [selectedValue])

  return (
    <div className="relative h-content w-4 h-4" ref={wrapperRef}>
      {children}
      <AnimateSharedLayout type="crossfade">
        <AnimatePresence>
          {visible && (
            <div className="absolute top-full mt-4 -right-2 z-50 dark:border-gray-800 w-48">
              <motion.div
                className="rounded p-1.5 relative shadow-md bg-white dark:bg-gray-900 w-full"
                initial="closed"
                animate="open"
                exit="closed"
                transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
                variants={{
                  open: { opacity: 1 },
                  closed: { opacity: 0 },
                }}
              >
                {onCustomButtons?.length &&
                  onCustomButtons.map((btn) => {
                    return btn.display ? (
                      <div
                        key={btn.title}
                        className="py-1"
                        onClick={() => btn.action()}
                      >
                        <Button
                          type="link"
                          classes={`text-black hover:text-primary text-left ${
                            btn.color || ''
                          }`}
                        >
                          <div className="flex items-center gap-2">
                            {btn.icon && <span>{btn.icon}</span>}
                            <span>{btn.title}</span>
                          </div>
                        </Button>
                      </div>
                    ) : (
                      <></>
                    )
                  })}

                {onSendToCatalog && (
                  <div className="py-1" onClick={() => onSendToCatalog()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Enviar a catálogo
                    </Button>
                  </div>
                )}

                {onAddEditInvoice && (
                  <div className="py-1" onClick={() => onAddEditInvoice()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Añadir/Editar Factura
                    </Button>
                  </div>
                )}

                {watchPurchase && (
                  <div className="py-1" onClick={() => watchPurchase()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver compra
                    </Button>
                  </div>
                )}

                {onWatchDocument && (
                  <div className="py-1" onClick={() => onWatchDocument()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver documento
                    </Button>
                  </div>
                )}

                {watchSale && (
                  <div className="py-1" onClick={() => watchSale()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver venta
                    </Button>
                  </div>
                )}

                {onDownloadDigitalInvoice && (
                  <div
                    className="py-1"
                    onClick={() => onDownloadDigitalInvoice()}
                  >
                    <Button type="link" classes="text-black hover:text-primary">
                      Descargar Factura
                    </Button>
                  </div>
                )}

                {onDownloadIvaRetention && (
                  <div
                    className="py-1"
                    onClick={() => onDownloadIvaRetention()}
                  >
                    <Button type="link" classes="text-black hover:text-primary">
                      Descargar Ret. IVA
                    </Button>
                  </div>
                )}

                {onDownloadIslrRetention && (
                  <div
                    className="py-1"
                    onClick={() => onDownloadIslrRetention()}
                  >
                    <Button type="link" classes="text-black hover:text-primary">
                      Descargar Ret. ISLR
                    </Button>
                  </div>
                )}

                {watchIncome && (
                  <div className="py-1" onClick={() => watchIncome()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver Entrada
                    </Button>
                  </div>
                )}

                {watchOutflow && (
                  <div className="py-1" onClick={() => watchOutflow()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver Egreso
                    </Button>
                  </div>
                )}

                {onReturn && (
                  <div className="py-1" onClick={() => onReturn()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Añadir Devolución
                    </Button>
                  </div>
                )}

                {onReturnEdit && (
                  <div className="py-1" onClick={() => onReturnEdit()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Modificar Devolución
                    </Button>
                  </div>
                )}

                {onDeletePurchase && (
                  <div className="py-1" onClick={() => onDeletePurchase()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Eliminar Compra
                    </Button>
                  </div>
                )}

                {onRetention && (
                  <div className="py-1" onClick={() => onRetention()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Imprimir Retención IVA
                    </Button>
                  </div>
                )}

                {onRetentionISLR && (
                  <div className="py-1" onClick={() => onRetentionISLR()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Imprimir Retención ISLR
                    </Button>
                  </div>
                )}

                {onCancelSale && (
                  <div className="py-1" onClick={() => onCancelSale()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Anular
                    </Button>
                  </div>
                )}

                {onCancelInvoice && (
                  <div className="py-1" onClick={() => onCancelInvoice()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Anular factura
                    </Button>
                  </div>
                )}

                {onAddPayment && (
                  <div className="py-1" onClick={() => onAddPayment()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Añadir Pago
                    </Button>
                  </div>
                )}

                {onPay && (
                  <div className="py-1" onClick={() => onPay()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Pagar
                    </Button>
                  </div>
                )}

                {onAddReceivedProducts && (
                  <div className="py-1" onClick={() => onAddReceivedProducts()}>
                    {/* <Button
                      type="link"
                      classes="text-black hover:text-primary"

                    >
                      Agregar Pdtos. Recibidos
                    </Button> */}

                    <button
                      type="button"
                      style={{ borderColor: 'transparent' }}
                    >
                      <p
                        className="hover:text-primary dark:hover:text-primary  dark:text-gray-400 ml-1.5 font-medium tracking-wide text-dark"
                        style={{ display: 'block', textAlign: 'start' }}
                      >
                        Agregar Pdtos. Recibidos
                      </p>
                    </button>
                  </div>
                )}

                {onAddSubCategory && (
                  <div className="py-1" onClick={() => onAddSubCategory()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Añadir Subcategoría
                    </Button>
                  </div>
                )}

                {onCreditNote && (
                  <div className="py-1" onClick={() => onCreditNote()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Histórico de créditos
                    </Button>
                  </div>
                )}

                {onDeleteFromCatalog && (
                  <div className="py-1" onClick={() => onDeleteFromCatalog()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Eliminar de catálogo
                    </Button>
                  </div>
                )}

                {onDay && (
                  <div
                    className="py-1"
                    onClick={() => onDay()}
                    style={{
                      background:
                        cardStates[selectedValue] === 'day'
                          ? '#75b8fa'
                          : 'none',
                      opacity: cardStates[selectedValue] === 'day' ? 0.8 : 1,
                    }}
                  >
                    <Button
                      type="link"
                      classes="text-black hover:text-primary dark:text-white"
                    >
                      Por día
                    </Button>
                  </div>
                )}

                {onMonth && (
                  <div
                    className="py-1"
                    onClick={() => onMonth()}
                    style={{
                      background:
                        cardStates[selectedValue] === 'month'
                          ? '#75b8fa'
                          : 'none',
                      opacity: cardStates[selectedValue] === 'month' ? 0.8 : 1,
                    }}
                  >
                    <Button
                      type="link"
                      classes="text-black hover:text-primary dark:text-white"
                    >
                      Por mes
                    </Button>
                  </div>
                )}

                {onAnnual && (
                  <div
                    className="py-1"
                    onClick={() => onAnnual()}
                    style={{
                      background:
                        cardStates[selectedValue] === 'annual'
                          ? '#75b8fa'
                          : 'none',
                      opacity: cardStates[selectedValue] === 'day' ? 0.8 : 1,
                    }}
                  >
                    <Button
                      type="link"
                      classes="text-black hover:text-primary dark:text-white"
                    >
                      Por año
                    </Button>
                  </div>
                )}

                {onWatchAccounts && (
                  <div className="py-1" onClick={() => onWatchAccounts()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver cuentas
                    </Button>
                  </div>
                )}

                {onCost && (
                  <div className="py-1" onClick={() => onCost()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Costo
                    </Button>
                  </div>
                )}

                {onPrice && (
                  <div className="py-1" onClick={() => onPrice()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Precio
                    </Button>
                  </div>
                )}

                {onFiles && (
                  <div onClick={() => onFiles()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Documentos
                    </Button>
                  </div>
                )}

                {onAssembly && (
                  <div className="py-1" onClick={() => onAssembly()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ensamblar
                    </Button>
                  </div>
                )}

                {onClients && (
                  <div className="py-1" onClick={() => onClients()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Clientes
                    </Button>
                  </div>
                )}

                {onConvertToSale && (
                  <div className="py-1" onClick={() => onConvertToSale()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      <div className="ml-0.5">Venta</div>
                    </Button>
                  </div>
                )}

                {onReprint && (
                  <div className="py-1" onClick={() => onReprint()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Reimprimir
                    </Button>
                  </div>
                )}

                {withholdingIVA && (
                  <div className="py-1" onClick={() => withholdingIVA()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Retención IVA
                    </Button>
                  </div>
                )}

                {withholdingISLR && (
                  <div className="py-1" onClick={() => withholdingISLR()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Retención ISLR
                    </Button>
                  </div>
                )}

                {aeWithholding && (
                  <div className="py-1" onClick={() => aeWithholding()}>
                    <Button
                      type="link"
                      classes="text-black hover:text-primary"
                      textStyle={{ textAlign: 'start' }}
                    >
                      Retención impuesto municipal
                    </Button>
                  </div>
                )}

                {otherWitholding && (
                  <div className="py-1" onClick={() => otherWitholding()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Otras retenciones
                    </Button>
                  </div>
                )}

                {OnPrintProps && <PdfButton {...OnPrintProps} />}

                {onCompound && (
                  <div className="py-1" onClick={() => onCompound()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Composicion
                    </Button>
                  </div>
                )}

                {addRawMaterial && (
                  <div className="py-1" onClick={() => addRawMaterial()}>
                    <Button
                      type="link"
                      classes="text-black hover:text-primary text-left"
                    >
                      Añadir / Ver materia prima
                    </Button>
                  </div>
                )}

                {onTracking && (
                  <div className="py-1" onClick={() => onTracking()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Monitoreo
                    </Button>
                  </div>
                )}

                {onAssociated && (
                  <div className="py-1" onClick={() => onAssociated()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Codigos
                    </Button>
                  </div>
                )}

                {onTaxMachine && (
                  <div className="py-1" onClick={() => onTaxMachine()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Asociar
                    </Button>
                  </div>
                )}

                {onBank && (
                  <div className="py-1" onClick={() => onBank()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Cuentas
                    </Button>
                  </div>
                )}
                {onSubCategory && (
                  <div className="py-1" onClick={() => onSubCategory()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Sub Categoria
                    </Button>
                  </div>
                )}
                {onDetails && (
                  <div className="py-1" onClick={() => onDetails()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Detalles
                    </Button>
                  </div>
                )}

                {onComplete && (
                  <div className="py-1" onClick={() => onComplete()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Completar
                    </Button>
                  </div>
                )}

                {onEdit && (
                  <div className="py-1" onClick={() => onEdit()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Editar
                    </Button>
                  </div>
                )}

                {onSendWhatsappMessage && (
                  <div className="py-1" onClick={() => onSendWhatsappMessage()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Contactar por whatsapp
                    </Button>
                  </div>
                )}

                {onShow && (
                  <div className="py-1" onClick={() => onShow()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Detalles
                    </Button>
                  </div>
                )}

                {onCredit && (
                  <div className="py-1" onClick={() => onCredit()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Crédito
                    </Button>
                  </div>
                )}

                {onDisable && (
                  <div className="py-1" onClick={() => onDisable()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Deshabilitar
                    </Button>
                  </div>
                )}

                {onEnable && (
                  <div className="py-1" onClick={() => onEnable()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Habilitar
                    </Button>
                  </div>
                )}

                {setVisible && (
                  <div className="py-1" onClick={() => setVisible()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      {cardVisible ? 'Ocultar' : 'Mostrar'}
                    </Button>
                  </div>
                )}

                {setNotVisible && (
                  <div className="py-1" onClick={() => setNotVisible()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      {cardVisible ? 'Ocultar' : 'Mostrar'}
                    </Button>
                  </div>
                )}

                {onSales && (
                  <div className="py-1" onClick={() => onSales()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ventas
                    </Button>
                  </div>
                )}

                {onRefund && (
                  <div className="py-1" onClick={() => onRefund()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Devolución
                    </Button>
                  </div>
                )}

                {onAdd && (
                  <div className="py-1" onClick={() => onAdd()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Completar
                    </Button>
                  </div>
                )}

                {onDownload && (
                  <div className="py-1" onClick={() => onDownload()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Descargar
                    </Button>
                  </div>
                )}

                {onDelete && (
                  <div className="py-1" onClick={() => onDelete()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Eliminar
                    </Button>
                  </div>
                )}

                {onCancel && (
                  <div className="py-1" onClick={() => onCancel()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Cancelar
                    </Button>
                  </div>
                )}

                {onWatchDetails && (
                  <div className="py-1" onClick={() => onWatchDetails()}>
                    <Button type="link" classes="text-black hover:text-primary">
                      Ver detalle
                    </Button>
                  </div>
                )}
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      </AnimateSharedLayout>
    </div>
  )
}

export default FloatingMenu
interface FloatingMenuProps {
  children: any
  visible: boolean
  onClose: Function
  options: {
    onDelete?: Function
    onEdit?: Function
    onDetails?: Function
    onBank?: Function
    onSubCategory?: Function
    onAssociated?: Function
    onTaxMachine?: Function
    onTracking?: Function
    onCompound?: Function
    onPrice?: Function
    setVisible?: Function
    setNotVisible?: Function
    cardVisible?: boolean
    onRefund?: Function
    onAdd?: Function
    onReprint?: Function
    withholdingIVA?: Function
    withholdingISLR?: Function
    OnPrintProps?: PdfViewProps
    onConvertToInvoice?: Function
    onConvertToFreeForm?: Function
    onConvertToSale?: Function
    onClients?: Function
    onSales?: Function
    onCredit?: Function
    onDisable?: Function
    onEnable?: Function
    onComplete?: Function
    onCancel?: Function
    onAssembly?: Function
    onFiles?: Function
    onDownload?: Function
    onSendToCatalog?: Function
    onDeleteFromCatalog?: Function
    onCreditNote?: Function
    onShow?: Function
    onCost?: Function
    onAddEditInvoice?: Function
    watchPurchase?: Function
    watchSale?: Function
    onDownloadDigitalInvoice?: Function
    onDownloadIvaRetention?: Function
    onDownloadIslrRetention?: Function
    onDeletePurchase?: Function
    onAddPayment?: Function
    onAddReceivedProducts?: Function
    onAddSubCategory?: Function
    watchIncome?: Function
    watchOutflow?: Function
    onCustomButtons?: {
      title: string
      action: Function
      display: boolean
      icon?: React.ReactNode
      color?: string
    }[]
    onReturn?: Function
    onReturnEdit?: Function
    addRawMaterial?: Function
    onSendWhatsappMessage?: Function
    onCancelSale?: Function
    onDay?: Function
    onMonth?: Function
    onAnnual?: Function
    onWatchAccounts?: Function
    otherWitholding?: Function
    aeWithholding?: Function
    onPay?: Function
    onRetention?: Function
    onRetentionISLR?: Function
    onWatchDocument?: Function
    onCancelInvoice?: Function
    onWatchDetails?: Function
  }
}
